
export default function BoxContainer({title,subtitle,children}) {
    return (
        <div className="bg-white p-4 rounded-md">
            <div>
                <h1 className="font-bold text-[22px]">{title}</h1>
                <p className="text-gray-500 text-sm">{subtitle}</p>
            </div>
            <div className="mt-8">
                {children}
            </div>
        </div>
    )
}
